import { useEffect, useState } from "react";
import { Header } from "../../components/Header";
import { Link } from "react-router-dom";
import { toast } from "react-toastify"
import './favoritos.css'


export const Favoritos = ()=> {

  const [filmes, setFilmes] = useState([]);

  useEffect(()=>{

    const minhaLista = localStorage.getItem('filmes');
    setFilmes(JSON.parse(minhaLista) || [])

  },[]);

  function handleDelete(id){
    let filtroFilmes = filmes.filter((item)=>{
      return(item.id !== id)
    })

    setFilmes(filtroFilmes);
    localStorage.setItem('filmes', JSON.stringify(filtroFilmes))
    toast.success('Fillme excluído com sucesso!')
  }


  return (
    <div>
        <Header></Header>
        <div className="container container-fav">
          <h1 className="fav">Meus Filme Favoritos</h1>

          {filmes.length === 0 && <span>Sua lista de favoritos está vazio</span>}

          <ul>
            {filmes.map((item)=>{
                  return(
                    <li key={item.id} className="lista-filmes lista-filme-fav">
                      <span className="titulo">{item.nome}</span>
                      <div className="opcoes">
                        <Link className="detalhes" to={`/filme/${item.id}`}>Ver Detalhes</Link>
                        <button  onClick={ ()=> handleDelete(item.id)}>Excluir</button>
                      </div>
                    </li>
                  )
                })}
          </ul>
        </div>
    </div>
  );
}


